import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "horizontalAlign", "titleText", "verticalAlign", "width"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ItemContainer = styled.div.withConfig({
  displayName: "MultiColumnItem__ItemContainer",
  componentId: "sc-1h75lnf-0"
})(["", " text-align:", ";vertical-align:", ";width:", ";@media only screen and (min-width:576px){display:table-cell;border-width:1px 0 0;border-style:solid;border-color:", ";&:last-child:not(:first-child){text-align:", ";}}", ";"], ({
  theme
}) => `
    padding-block: ${theme.space[400]};
    padding-inline: ${theme.space[600]};
    /* replaces the has--vertical-spacing className styling */
    & > :last-child {
      margin-bottom: ${theme.space[0]};
    }
  `, props => props.$horizontalAlign || 'left', props => props.$verticalAlign || 'middle', props => props.$width, ({
  theme
}) => theme.color['border-core-subtle'], props => props.$horizontalAlign || 'right', ({
  $cssStyles
}) => $cssStyles);
const ItemTitle = styled.span.withConfig({
  displayName: "MultiColumnItem__ItemTitle",
  componentId: "sc-1h75lnf-1"
})(["display:block;margin-bottom:", ";", ""], ({
  theme
}) => theme.space[100], ({
  theme
}) => theme.typography['heading-100']);
export const MultiColumnItem = _ref => {
  let {
      children,
      horizontalAlign,
      titleText,
      verticalAlign = 'middle',
      width
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    dataProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(ItemContainer, Object.assign({}, dataProps, {
    $horizontalAlign: horizontalAlign,
    $verticalAlign: verticalAlign,
    $width: width,
    $cssStyles: cssStyles,
    children: [titleText && /*#__PURE__*/_jsx(ItemTitle, {
      children: titleText
    }), children]
  }));
};